export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'manage',
    subject: 'all',
  },
  {
    action: 'manage',
    subject: 'Auth',
  },
]

export const _ = undefined
